import { DOCUMENT } from '@angular/common';
import { Injectable, Inject, NgZone } from '@angular/core';
import { ViewportRuler } from '@angular/cdk/overlay';
import { map } from 'rxjs/operators';
import {
  NbPlatform,
  NbLayoutRulerService,
  NbLayoutScrollService,
} from '@nebular/theme';

/**
 * Fix for Nebular 6 + Angular 11: NbViewportRulerAdapter does not pass DOCUMENT to CDK ViewportRuler,
 * causing "Cannot read properties of undefined (reading 'defaultView')".
 * This adapter injects DOCUMENT and passes it to the CDK ViewportRuler, and delegates viewport size/scroll
 * to Nebular's ruler/scroll services like the original adapter.
 */
@Injectable()
export class ViewportRulerAdapterFix extends ViewportRuler {
  constructor(
    platform: NbPlatform,
    ngZone: NgZone,
    private ruler: NbLayoutRulerService,
    private scroll: NbLayoutScrollService,
    @Inject(DOCUMENT) document: Document
  ) {
    super(platform, ngZone, document);
  }

  getViewportSize(): Readonly<{ width: number; height: number }> {
    let res: { width: number; height: number } = { width: 0, height: 0 };
    this.ruler
      .getDimensions()
      .pipe(map((d) => ({ width: d.clientWidth, height: d.clientHeight })))
      .subscribe((rect) => (res = rect));
    return res;
  }

  getViewportScrollPosition(): { top: number; left: number } {
    let res: { top: number; left: number } = { top: 0, left: 0 };
    this.scroll
      .getPosition()
      .pipe(map((p) => ({ top: p.y, left: p.x })))
      .subscribe((position) => (res = position));
    return res;
  }
}
